import { generatePath } from 'quartz-routing/react-router';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../constants/Navigation.legacy';
export const getMyPlaylistsUrl = ({
  tab,
  page
} = {}) => {
  return generatePath(`${MY_PLAYLISTS_URL_FRAGMENT}/:tab?${page ? tab ? '/page/:page' : 'page/:page' : ''}`, {
    tab,
    page
  });
};